//Changing this file require change in server also, for security and performance reason

export const ProductLicenses = {
    INVCCCP: {
        Product: "inClinic Concurrent Plan",
        Descirption: "inClinic Concurrent Plan - $26.08 per Concurrent doctor per month , Billed annually.",
        Price: 26.08,
        Currency: "USD",
        Tax: 18,
    },
    INVCPLUSCCP: {
        Product: "InVC Plus Concurrent Plan",
        Descirption: "InVC Plus Concurrent Plan - $5 per concurrent user per month, Billed annually.",
        Price: 5,
        Currency: "USD",
        Tax: 18,
    },
    INVCPROCCP: {
        Product: "InVC Pro Concurrent Plan",
        Descirption: "InVC Pro Concurrent Plan - $10 per concurrent user per month, Billed annually.",
        Price: 10,
        Currency: "USD",
        Tax: 18,
    },
    INVCHOST100: {
        Product: "InVC Host 1:100 Plan",
        Descirption: "InVC Host Plan - $17 per host per month, Billed annually.",
        Price: 17,
        Currency: "USD",
        Tax: 18,
    },
    INVCHOST300: {
        Product: "InVC Host 1:300 Plan",
        Descirption: "InVC Host Plan - $21 per host per month, Billed annually.",
        Price: 21,
        Currency: "USD",
        Tax: 18,
    },
    INVCHOST500: {
        Product: "InVC Host 1:500 Plan",
        Descirption: "InVC Host Plan - $24 per host per month, Billed annually.",
        Price: 24,
        Currency: "USD",
        Tax: 18,
    },
    INVCFREE: {
        Product: "inclinic Free Plan",
        Descirption: "inclinic Free Plan - free for 14 days.",
        Price: 0,
        Currency: "USD",
        Tax: 0,
        productType: "inclinic",
        isConcurrent: true,
    },
};
